import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Get stored language before initialization
const storedLanguage = localStorage.getItem('language');

i18n
  // Load translations from /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    lng: storedLanguage || undefined, // Use stored language if available
    fallbackLng: 'en',
    supportedLngs: ['en', 'da', 'de', 'es', 'fr', 'it', 'pt', 'ar', 'ja', 'zh', 'ru'],
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
    
    // React settings
    react: {
      useSuspense: true,
    },
    
    // Namespaces for organizing translations
    ns: ['common', 'landing', 'auth', 'dashboard', 'campaign'],
    defaultNS: 'common',
  });

export default i18n;

// RTL languages list for future support
export const rtlLanguages = ['ar'];

// Check if current language is RTL
export const isRTL = (lang) => rtlLanguages.includes(lang);

// Language names for display
export const languageNames = {
  en: 'English',
  da: 'Dansk',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  pt: 'Português',
  ar: 'العربية',
  ja: '日本語',
  zh: '中文',
  ru: 'Русский'
};
